import { render, staticRenderFns } from "./HomeNew.vue?vue&type=template&id=61b6e22f&scoped=true"
import script from "./HomeNew.vue?vue&type=script&lang=js"
export * from "./HomeNew.vue?vue&type=script&lang=js"
import style0 from "./HomeNew.vue?vue&type=style&index=0&id=61b6e22f&prod&scoped=true&lang=css"
import style1 from "./HomeNew.vue?vue&type=style&index=1&id=61b6e22f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b6e22f",
  null
  
)

export default component.exports